import React, { Component } from "react";
import PropTypes from "prop-types";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Check from "@material-ui/icons/Add";
// import Initial from "react-initial";
import withStyles from "@material-ui/core/styles/withStyles";
import { withRouter } from "react-router";
import SweetAlert from "react-bootstrap-sweetalert";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import { connect } from "react-redux";

import { pushLoader } from "actions/main";

import { pushWorkspace, fetchWorkspace } from "../../api/workspace";

import { pushWorkspaceList, pushWorkspaceID } from "../../actions/workspace";

class Workspacelist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      show: false,
      user_id: localStorage.getItem("id"),
      workspacedata: []
    };
    this.inputConfirmAlert = this.inputConfirmAlert.bind(this);
  }

  UNSAFE_componentWillMount() {
    fetchWorkspace()
      .then(response => {
        this.props.pushLoader(false);
        this.props.pushWorkspaceList(response.data.results);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  componentWillReceiveProps(nextProps){
      console.log(nextProps.workspaceList);
      this.setState({ workspacedata: nextProps.workspaceList });
  }

  inputAlert() {
    this.setState({
      alert: (
        <SweetAlert
          input
          showCancel
          style={{ display: "block", marginTop: "-100px" }}
          title="Workspace Title"
          onConfirm={e => this.inputConfirmAlert(e)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.info
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
        />
      )
    });

    console.log(this.state.alert);
  }

  inputConfirmAlert(e) {
    this.setState({ alert: "" });

    pushWorkspace(e, this.state.user_id)
      .then(() => {
        this.props.pushLoader(false);
        fetchWorkspace()
          .then(response => {
            this.props.pushWorkspaceList(response.data.results);
          })
          .catch(error => {
            console.log(error);
            this.props.history.push("/pages/login#logout");
          });
        setTimeout(this.hideAlert, 2000);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  inputConfirmAlertNext() {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
        />
      )
    });
  }

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  renderWorkspaceData = (data) => {
    return (
      <GridItem xs={12} md={2}>
        <Card>
          <CardHeader>
            <div>
              {/* <Initial name = {data["name"]} fontSize ='40' height='50' width='50 '/> */}
              <span> {data["name"]}</span>
            </div>
          </CardHeader>
          <CardBody>
            {/*<HighchartsReact
              highcharts={Highcharts}
              options={options}
            />*/}
          </CardBody>
          <CardFooter stats>
            <a style = {{cursor:"pointer"}} 
              onClick={()=>{
                this.props.pushWorkspaceID(data["id"]);
                this.props.history.push("/wdetail");
              }}
            >
               Go to Workspace
            </a>
          </CardFooter>
        </Card>
      </GridItem>
    );
  }

  render() {
    return (
      <div>
        {this.state.alert}
        <Button
          variant="outlined"
          color="default"
          onClick={this.inputAlert.bind(this)}
        >
          <Check /> Add Workspace
        </Button>

        <GridContainer>
          {this.state.workspacedata.map(this.renderWorkspaceData)}
        </GridContainer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    workspaceList: state.workspaceList
  };
}

Workspacelist.propTypes = {
  classes: PropTypes.object.isRequired,
  pushLoader: PropTypes.string,
  history: PropTypes.object
};

export default withStyles(sweetAlertStyle)(
  withRouter(
    connect(
      mapStateToProps,
      { pushLoader, pushWorkspace, pushWorkspaceList, pushWorkspaceID }
    )(Workspacelist)
  )
);
